export * from './lawsuit-two-offers-lock'
